import { ChangeDetectionStrategy, Component, HostBinding, inject } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';
import { Store } from '@ngrx/store';

import { Actions } from './actions';

@Component({
    selector: 'ms-unpin-info',
    templateUrl: './unpin-info.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [IconCustomComponent],
})
export class UnpinInfoComponent {
    sitecore = inject(Sitecore);
    private store = inject(Store);

    @HostBinding('class') className = 'unpin-info';

    close(): void {
        this.closeInfoMessage();
    }

    private closeInfoMessage(): void {
        this.store.dispatch(Actions.acceptUnpinInfoMessage());
    }
}
